import { createPubSub } from './createPubSub'
import {
    alertsInterceptors,
    listInterceptors,
    userInterceptors,
} from './interceptors'

export const pubSubAlerts = createPubSub('ALERTS_', alertsInterceptors)
export const pubSubAppState = createPubSub('APPSTATE_')
export const pubSubChatCommands = createPubSub('CHAT_COMMANDS_')
export const pubSubLayout = createPubSub('LAYOUT_')
export const pubSubMail = createPubSub('MAIL_')
export const pubSubMessages = createPubSub('MESSAGES_')
export const pubSubArchives = createPubSub('ARCHIVES_')
export const pubSubNotes = createPubSub('NOTES_')
export const pubSubModelBrowser = createPubSub('MODELBROWSER_')
export const pubSubVideoAvatarFeed = createPubSub('VIDEOAVATARFEED_')
export const pubSubMyml = createPubSub('MYML_')
export const pubSubRooms = createPubSub('ROOMS_')
export const pubSubRoomHistory = createPubSub('ROOMHISTORY_')
export const pubSubSearch = createPubSub('SEARCH_')
export const pubSubSecureState = createPubSub('SECURESTATE_')
export const pubSubSettings = createPubSub('SETTINGS_')
export const pubSubSidebar = createPubSub('SIDEBAR_')
export const pubSubTimer = createPubSub('TIMER_')
export const pubSubWhiteboard = createPubSub('WHITEBOARD_')
export const pubSubVideo = createPubSub('VIDEO_')
export const pubSubList = createPubSub('LIST_', listInterceptors)
export const pubSubUsers = createPubSub('USERS_', userInterceptors)
export const pubSubRouter = createPubSub('ROUTE_')
export const pubSubNews = createPubSub('NEWS_')
export const pubSubHealth = createPubSub('HEALTH_')
export const pubSubScreen = createPubSub('SCREEN_')
export const pubSubGrid = createPubSub('GRID_')
export const pubSubModal = createPubSub('MODAL_')
export const pubSubModalStack = createPubSub('MODALSTACK_')
export const pubSubDebug = createPubSub('DEBUG_')
export const pubSubTippedModels = createPubSub('TIPPEDMODELS_')
